import { AccordionEnhancedWrapperProps } from '@ahc-digital/component-library';
import { Placeholder } from '@sitecore-jss/sitecore-jss-nextjs';
import { Fragment } from 'react';
import { getDroplink } from '@/shared/param-utils';
import { useConditionalRendering } from '@/shared/useConditionalRendering';
import { C36AccordionEnhancedProps } from './C36AccordionEnhanced.types';
import { ACCORDION_ENHANCED_ITEM_CONTAINER } from '@/shared/static';

const AccordionOpenValueMarker = ({ value }: { value: string }) => <Fragment key={value} />;

export function CreateC36AccordionEnhancedModel(props?: C36AccordionEnhancedProps) {
  type t = AccordionEnhancedWrapperProps;
  const { fields, params, rendering } = props || {};
  const { renderText, renderRichText } = useConditionalRendering();

  const itemValues = (rendering?.placeholders?.[ACCORDION_ENHANCED_ITEM_CONTAINER] || [])
    .map(({ uid }) => uid)
    .filter((uid): uid is string => !!uid);

  return {
    accordionEnhancedItems: rendering ? (
      <>
        <Placeholder name={ACCORDION_ENHANCED_ITEM_CONTAINER} rendering={rendering} />
        {/* Expose item values that the library cannot discover through Placeholder. */}
        {itemValues.map((value) => (
          <AccordionOpenValueMarker key={value} value={value} />
        ))}
      </>
    ) : (
      <></>
    ),
    headline: renderText(fields?.Headline) as t['headline'],
    headlineAlignment: getDroplink<t['headlineAlignment']>(params?.HeadlineAlignment, 'left'),
    headlineIcon: getDroplink<t['headlineIcon']>(params?.HeadlineIcon),
    headlineIconPlacement: getDroplink<t['headlineIconPlacement']>(
      params?.HeadlineIconPlacement,
      'left'
    ),
    headlineTag: getDroplink<t['headlineTag']>(params?.HeadlineTag, 'h3'),
    supportCopy: renderRichText(fields?.SupportCopy),
    supportCopyBottom: renderRichText(fields?.SupportCopyBottom),
    backgroundColor: getDroplink<t['backgroundColor']>(params?.BackgroundColor, 'white'),
    shouldOpenFirstItem: !!params?.OpenFirstItem,
    type: (params?.LimitToSingleItem ? 'single' : 'multiple') as t['type'],
  };
}
